import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModulosComponent } from './modulos/components/modulos/modulos.component';

const routes: Routes = [
  {
    path: "menu",
    loadChildren: () => import('src/app/modules/admin/modules/superadmin/modulos/modulos.module').then(m => m.ModulosModule)
  },
  {
    path: "cierre",
    loadChildren: () => import('src/app/modules/admin/modules/superadmin/cierre/cierre.module').then(m => m.CierreModule)
  },
  {
    path: "config",
    loadChildren: () => import('src/app/modules/admin/modules/superadmin/config/config.module').then(m => m.ConfigModule)
  },
  { path: "", redirectTo: "menu", pathMatch: "prefix" }, { path: "**", redirectTo: "menu", pathMatch: "prefix" },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SuperadminRoutingModule { }
